import { render, staticRenderFns } from "./supportiveBank.vue?vue&type=template&id=5f05cda6&scoped=true"
import script from "./supportiveBank.vue?vue&type=script&lang=js"
export * from "./supportiveBank.vue?vue&type=script&lang=js"
import style0 from "./supportiveBank.vue?vue&type=style&index=0&id=5f05cda6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f05cda6",
  null
  
)

export default component.exports